import HeaderHelpMenuPopoverComponent from './header-help-menu-popover.component'

const HeaderHelpMenuPopoverModule = angular.module('cdbl.header-help-menu-popover', [

])
  .component('cdblHeaderHelpMenuPopover', HeaderHelpMenuPopoverComponent)
  .name

export default HeaderHelpMenuPopoverModule
